export default "__VITE_ASSET__Cw7JP_6a__"